import JDSDatepickerDesktop from '@jds/react-generated-sdl/JDSDatepickerDesktop';
import JDSDatepickerMobile from '@jds/react-generated-sdl/JDSDatepickerMobile';
import type { JDSDatepickerDesktopProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DatePickerProps } from '../logic';

const Component = (props: DatePickerProps) => {
  const { platform } = useTokenValues();

  const json =
    platform === 'desktop' ? JDSDatepickerDesktop : JDSDatepickerMobile;
  const {
    state = 'default',
    open = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, open, ...rest },
    'JDSDatepickerDesktop',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatePicker = withLogic(Component) as React.FC<DatePickerProps> & {
  slotName?: string;
};

DatePicker.displayName = 'DatePicker';
DatePicker.slotName = 'jds_datepicker_desktop';

export { DatePicker, type JDSDatepickerDesktopProps };
